// ponytail: side-effect <style> injection, not a component — importing @plecto/ui
// is enough. Move to createGlobalStyle only if these rules ever need the theme.
import { mainTheme } from '../themes/mainTheme';

const CSS = `
/* Platform scrollbars: 8px thumb, no track, no gutter, one flat colour.
   Chrome disables ::-webkit-scrollbar sizing whenever scrollbar-width is not
   \`auto\`, so the standard properties are gated to engines without the webkit
   pseudo-elements (Firefox), where \`thin\` is the closest available value. */
@supports not selector(::-webkit-scrollbar) {
	*,
	::backdrop {
		scrollbar-width: thin;
		scrollbar-color: ${mainTheme.fill.dimmedSecondary} transparent;
	}
}

::-webkit-scrollbar {
	width: 8px;
	height: 8px;
	background: transparent;
}

::-webkit-scrollbar-thumb {
	background: ${mainTheme.fill.dimmedSecondary};
	border-radius: 80px;
	border: 0;
	box-shadow: none;
}

/* Chrome falls back to its own native hover/active thumb unless both states
   are stated explicitly. The bar is one flat colour in every state. */
::-webkit-scrollbar-thumb:hover,
::-webkit-scrollbar-thumb:active,
::-webkit-scrollbar-thumb:window-inactive {
	background: ${mainTheme.fill.dimmedSecondary};
}

/* Track, corner and stepper buttons each paint a native face and a 1px
   outline of their own. Nothing here should be visible. */
::-webkit-scrollbar-track,
::-webkit-scrollbar-track-piece,
::-webkit-scrollbar-corner {
	background: transparent;
	border: 0;
	box-shadow: none;
}

::-webkit-scrollbar-button {
	display: none;
	width: 0;
	height: 0;
}
`;

const ID = 'plecto-ui-scrollbar';

if (typeof document !== 'undefined' && !document.getElementById(ID)) {
	const style = document.createElement('style');
	style.id = ID;
	style.textContent = CSS;
	// First child of <head>: consumer stylesheets and styled-components stay able to override.
	// Not prepend(): Chrome 54+, and webOS 3/4 TVs run Chromium 38/53.
	try {
		document.head.insertBefore(style, document.head.firstChild);
	} catch {
		// Runs on import: a throw here would blank the whole app, not just the scrollbars.
	}
}

export {};
